type Option = { label: string; value: string };

/** Query to create when allowCreate is on and nothing matches case-insensitively. */
export function comboboxCreateQuery(
  allowCreate: boolean,
  query: string,
  options: Option[]
): string | null {
  const createQuery = query.trim();
  if (!allowCreate || !createQuery) return null;
  const needle = createQuery.toLowerCase();
  const matches = options.some(
    (o) =>
      o.label.toLowerCase() === needle || o.value.toLowerCase() === needle
  );
  return matches ? null : createQuery;
}
